//
// Copyright (c) 2026 Comcast
//

import listenerMiddleware from 'listenerMiddleware'
import i18next from 'i18next'
import { navigate } from 'reducers/routing'

import { updateSessionUserParam } from 'api/sessionUser'
import * as sessionUserSelector from 'selectors/sessionUser'
import * as ticketingSystemsSelector from 'selectors/ticketingSystems'

import {
  addNotification,
  clearNotification,
  notificationButtonClick,
} from 'reducers/notification'
import { appIsLoaded } from 'reducers/session'

import {
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_LAST_RELEASE_DETECTED,
} from 'constants/notification'

import { RouteReleaseNotes } from 'routes'

listenerMiddleware.startListening({
  actionCreator: appIsLoaded,
  effect: (action, listenerApi) => {
    const state = listenerApi.getState()

    const ticketingSystems = ticketingSystemsSelector.ticketingSystems(state) || []
    const notificationReleaseNote = sessionUserSelector.notificationReleaseNote(state)

    const showNotification = notificationReleaseNote && ticketingSystems.length > 0

    if (showNotification) {
      listenerApi.dispatch(addNotification({
        text: i18next.t('common.lastReleaseNoteNotification', { version: notificationReleaseNote.version }),
        type: NOTIFICATION_TYPE_SUCCESS,
        hideRefreshLink: true,
        isPersistent: true,
        notificationId: NOTIFICATION_LAST_RELEASE_DETECTED,
        actionButtons: [
          { text: i18next.t('common.goToReleaseNotes'), id: 'go-to-release-notes', icon: 'icon-arrow-right1' },
        ],
      }))
    }
  },
})

listenerMiddleware.startListening({
  actionCreator: notificationButtonClick,
  effect: async (action, listenerApi) => {
    const { notificationId } = action.payload

    if (notificationId !== NOTIFICATION_LAST_RELEASE_DETECTED) {
      return
    }

    const state = listenerApi.getState()
    const dispatch = listenerApi.dispatch
    const notificationReleaseNote = sessionUserSelector.notificationReleaseNote(state)

    await dispatch(updateSessionUserParam.initiate({ 'show_last_release_note': false })).unwrap()

    dispatch(clearNotification())
    dispatch(navigate(RouteReleaseNotes({ releaseNoteId: notificationReleaseNote?.id })))
  },
})

listenerMiddleware.startListening({
  actionCreator: clearNotification,
  effect: async (action, listenerApi) => {
    const notificationId = action.payload?.notificationId

    if (notificationId !== NOTIFICATION_LAST_RELEASE_DETECTED) {
      return
    }

    const dispatch = listenerApi.dispatch

    await dispatch(updateSessionUserParam.initiate({ 'show_last_release_note': false })).unwrap()
    dispatch(clearNotification())
  },
})
